// Form data interface for Client Intake
export interface ClientIntakeFormData {
  // Personal Information
  firstName: string;
  lastName: string;
  email: string;
  phone: string;

  // Wedding Details
  weddingDate: string;
  venue: string;
  budget: string;
  timeline: string;
  preference: string;

  // Style Preferences
  dressSilhouette: string[]; // Array of selected silhouettes
  preferredColors: string[]; // Array of selected colors
  neckline: string;

  // Additional Information
  size: string;
  specialRequests: string;
  howDidYouHear: string;
}

// Initial form state
export const initialFormData: ClientIntakeFormData = {
  // Personal Information
  firstName: '',
  lastName: '',
  email: '',
  phone: '',

  // Wedding Details
  weddingDate: '',
  venue: '',
  budget: '',
  timeline: '',
  preference: '',

  // Style Preferences
  dressSilhouette: [],
  preferredColors: [],
  neckline: '',

  // Additional Information
  size: '',
  specialRequests: '',
  howDidYouHear: '',
};

// Form validation interface
export interface FormErrors {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  // Add other field validations as needed
}

// Form submission response
export interface FormSubmissionResponse {
  success: boolean;
  message: string;
  errors?: FormErrors;
}

























